import { FunctionComponent } from 'react'
import { useMutation } from '@apollo/client'
import styles from './confirmDeleteChildDialog.module.scss'
import Dialog from '@/components/_custom/Dialog/Dialog'
import DialogHeader from '@/components/_custom/DialogHeader/DialogHeader'
import DialogBody from '@/components/_custom/DialogBody/DialogBody'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import { REMOVE_CHILD } from '@/modules/API/parent/childHandler'
import { Close, Delete } from '@mui/icons-material'
import { useNotification } from '@/modules/context/NotificationContext.tsx'

interface ConfirmDeleteChildProps {
    deleteChild?: (childId: number) => void
    childId: number
    daycareId?: number
    childFirstname: string
    open: boolean
    handleClose: () => void
}

const ConfirmDeleteChildDialog: FunctionComponent<ConfirmDeleteChildProps> = ({
    deleteChild,
    childId,
    daycareId,
    childFirstname,
    open,
    handleClose
}: ConfirmDeleteChildProps) => {
    const { t } = useTranslation()

    const { showNotificationSuccess, showNotificationError } = useNotification()

    const [removeChild] = useMutation(REMOVE_CHILD, {
        variables: {
            child_id: childId,
            daycare_id: daycareId
        },
        onCompleted: (): void => {
            if (deleteChild) {
                deleteChild(childId)
            }

            showNotificationSuccess(t('childDeleted'))

            handleClose()
        },
        onError: (): void => {
            showNotificationError(t('childNotDeleted'))
        }
    })

    return (
        <Dialog open={open} handleClose={handleClose}>
            <DialogHeader title={t('deleteChild')} />
            <DialogBody className={styles.DialogBody}>
                <p className={styles.Text}>{t('deleteChildMessage')}</p>
                <p className={styles.TextFamily}>{childFirstname}</p>
                <p className={styles.Text}>{t('noRollBack')}</p>
                <div className={styles.ButtonContainer}>
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('yes')}
                        customIcon={<Delete />}
                        onClick={removeChild}
                        className={styles.Button}
                    />
                    <ButtonTextIcon
                        type={'custom'}
                        customText={t('no')}
                        customIcon={<Close />}
                        onClick={handleClose}
                        className={styles.Button}
                    />
                </div>
            </DialogBody>
        </Dialog>
    )
}

export default ConfirmDeleteChildDialog
